export default __webpack_public_path__ + "static/media/Cadaverous Vambraces.cdcaed08.jpg";